@if (availableFileIcons.includes(getIconFileType())) {
  <geaui-icon-v3 class="size-160px" [file]="getIconFileType()" [fileSize]="24" [isFileIcon]="true" color="none"></geaui-icon-v3>
} @else {
  <geaui-icon-v3 class="size-160px" [fileSize]="24" [isFileIcon]="true" file="unknown" color="none"></geaui-icon-v3>
}
